export const DATA_REQUEST_FREE_TEXT_MAX_LENGTH = 10000;
export const DATA_REQUEST_FREE_TEXT_QUESTION_MAX_LENGTH = 500;
export const DATA_REQUEST_MAX_FREE_TEXT_QUESTIONS = 20;
